//packages
import React from 'react';
//global components
import { history } from '../_core/history';
//services
//styles

class PageNotFound extends React.Component {

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && Date.now() < user.expiresAt) {
      this.setState({
        user: user
      });
    } else {
      this.setState({
        user: {
          details: {}
        }
      });
    }
  }

  render() {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ background: "#E8E9EB", height: "100vh" }}>
        <h1 className="text-center" style={{ fontSize: "8vw", color: "#EF6461" }}>404</h1>
        <h2 className="text-center mb-5">We can't seem to find the page <br/>you are looking for.</h2>
        <a href='!#' className="btn btn-primary btn-lg p-3 text-white" onClick={()=>history.goBack()}>Back to Home</a>
      </div>
    );
  }
}

export default PageNotFound;